import { useEffect, useMemo } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
import { cn } from '@/lib/utils';
import { brandingConfig } from '@/config/branding';

export interface CalComPrefill {
	name?: string;
	email?: string;
}

interface CalComEmbedProps {
	className?: string;
	prefill?: CalComPrefill;
	onBookingConfirmed?: () => void;
}

const CAL_NAMESPACE = 'onboarding';

export function CalComEmbed({ className, prefill, onBookingConfirmed }: CalComEmbedProps) {
	const calComTeamSlug = brandingConfig.calComTeamSlug;
	const showCalCom = brandingConfig.features?.showCalCom !== false && Boolean(calComTeamSlug);

	useEffect(() => {
		if (!showCalCom) return;
		const initCal = async () => {
			const cal = await getCalApi({ namespace: CAL_NAMESPACE });
			cal('ui', {
				theme: 'light',
				hideEventTypeDetails: false,
				layout: 'month_view',
				cssVarsPerTheme: {
					light: {
						'cal-brand': '#000000',
					},
					dark: {
						'cal-brand': '#22c55e',
					},
				},
			});
			if (onBookingConfirmed) {
				cal('on', {
					action: 'bookingSuccessful',
					callback: () => onBookingConfirmed(),
				});
			}
		};
		initCal();
	}, [onBookingConfirmed, showCalCom]);

	const config = useMemo(() => ({
		layout: 'month_view' as const,
		theme: 'light' as const,
		...(prefill?.name ? { name: prefill.name } : {}),
		...(prefill?.email ? { email: prefill.email } : {}),
	}), [prefill?.name, prefill?.email]);

	if (!showCalCom) return null;

	return (
		<div className={cn('w-full', className)}>
			<Cal
				namespace={CAL_NAMESPACE}
				calLink={`team/${calComTeamSlug}`}
				style={{ width: '100%' }}
				config={config}
			/>
		</div>
	);
}
